module.exports = __webpack_public_path__ + "static/media/doubt_selected.3087ae2a.svg";